import { resolveActionVariablesInString } from '../helpers/jsonReplaceVariables';
import { TpDashboardActionContext, TpDbActionStepDefinition as TpDbActionStepTypeDefinition } from '../interfaces';

function getJsonSchema(): any {
  return {
    type: 'object',
    title: 'Set Chart Title ',
    description: 'Specifies a new title or description for an individual chart.',
    properties: {
      type: { type: 'string', const: 'SetChartTitle' },
      chartId: {
        type: 'string',
        description: 'Identifier of the chart in the dashboad template for which the title should be set.',
      },
      title: {
        type: 'string',
        description:
          'New title for the chart. Note that this text can refer to variables created earlier via "$VariableName"',
      },
      description: {
        type: 'string',
        description:
          'New description for the chart. Note that this text can contain markdown and refer to variables created earlier via "$VariableName"',
      },
    },
    required: ['type', 'chartId'],
  };
}

function execute(ctx: TpDashboardActionContext, step: any, onCompleted: () => void) {
  if (step.title == null && step.description == null) {
    onCompleted();
    return;
  }

  // in the template action definition, the user enters the same chart id as for the definition of the chart in the template
  const chartTemplateId = step.chartId;
  const chartDefs = ctx.dashboardContext.getChartDefsFromTemplateId(chartTemplateId);
  const chartIds = chartDefs.map((chartDef) => chartDef.id);

  if (step.title != null) {
    const title = resolveActionVariablesInString(ctx, step.title);
    chartIds.forEach((chartId) => {
      ctx.dashboardContext.updateChartCustomTitle(chartId, title);
    });
  }
  if (step.description != null) {
    const description = resolveActionVariablesInString(ctx, step.description);
    chartIds.forEach((chartId) => {
      ctx.dashboardContext.updateChartCustomDescription(chartId, description);
    });
  }
  onCompleted();
}

const dbActionStepSetChartTitle: TpDbActionStepTypeDefinition = {
  stepType: 'SetChartTitle',
  execute,
  getJsonSchema,
};

export default dbActionStepSetChartTitle;
